import { useState } from 'react' 
import { client } from '../context/provider'

function useExportDB () {
  const [ state, setState ] = useState({
    status: null,
    progress: null,
    error: null
  })

  const logProgress = progress => {
    const percent = (progress.completedRows / progress.totalRows * 100).toFixed()
    setState({ ...state, status: 'IN-PROGRESS', progress: `${percent}%` })
  }

  const handleExport = () => {
    client
      .export(logProgress)
      .then(result => {
        const newState = { ...state, status: result.status }
        if (result.error) {
          newState.error = result.error
        }
        setState(newState)
      })
      .catch(err => setState({
        ...state,
        status: 'FAIL',
        error: err,
      }))
  }

  return { state, handleExport }
}

export default useExportDB
